import {THEME} from '@wandb/weave/common/css/color.styles';
import styled from 'styled-components';

export const Link = styled.a`
  font-weight: 600;
  color: ${THEME.textLink};
  &:hover {
    color: light-dark(var(--teal-550), var(--teal-450));
  }
`;
Link.displayName = 'Link';
